module.exports = __webpack_public_path__ + "img/send.f0f7988f.png";